var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-clipboard-item-wrapper",
    },
    [
      _c("span", {
        staticClass: "cw-sortable-handle cw-sortable-handle-clipboard",
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "cw-clipboard-item",
          class: ["cw-clipboard-item-" + _vm.kind],
          on: {
            click: function click($event) {
              $event.preventDefault()
              return _vm.insertClipboardItem.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "header",
            {
              staticClass: "sr-only",
            },
            [_vm._v("\n            " + _vm._s(_vm.srTitle) + "\n        ")]
          ),
          _vm._v(" "),
          _c(
            "header",
            {
              staticClass: "cw-clipboard-item-title",
              attrs: {
                "aria-hidden": "true",
              },
            },
            [_vm._v("\n            " + _vm._s(_vm.name) + "\n        ")]
          ),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass: "cw-clipboard-item-description",
              attrs: {
                title: _vm.description,
              },
            },
            [_vm._v("\n            " + _vm._s(_vm.description) + "\n        ")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-clipboard-item-action-menu-wrapper",
        },
        [
          _c("studip-action-menu", {
            staticClass: "cw-clipboard-item-action-menu",
            attrs: {
              items: _vm.menuItems,
              context: _vm.name,
            },
            on: {
              insertItemCopy: _vm.insertClipboardItemCopy,
              editItem: _vm.showEditItem,
              deleteItem: _vm.deleteItem,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showEditDialog
        ? _c("studip-dialog", {
            attrs: {
              title: _vm.$gettext("Umbenennen"),
              confirmText: _vm.$gettext("Speichern"),
              confirmClass: "accept",
              closeText: _vm.$gettext("Abbrechen"),
              closeClass: "cancel",
              height: "360",
              width: "500",
            },
            on: {
              close: _vm.closeEditItem,
              confirm: _vm.storeItem,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dialogContent",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Titel")) +
                                "\n                    "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentClipboard.attributes.name,
                                  expression:
                                    "currentClipboard.attributes.name",
                                },
                              ],
                              attrs: {
                                type: "text",
                              },
                              domProps: {
                                value: _vm.currentClipboard.attributes.name,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.currentClipboard.attributes,
                                    "name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Beschreibung")) +
                                "\n                    "
                            ),
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.currentClipboard.attributes.description,
                                  expression:
                                    "currentClipboard.attributes.description",
                                },
                              ],
                              domProps: {
                                value:
                                  _vm.currentClipboard.attributes.description,
                              },
                              on: {
                                input: function input($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.currentClipboard.attributes,
                                    "description",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              944127991
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }